export interface PpIcon {
  type?: PpIconType;
  name: string;
  tooltip?: string;
  color?: string;
}

export enum PpIconType {
  Material = 1,
  Flaticon = 2,
}
